import React from 'react';

const IconSalesToolkit = () => (
  <svg
    version="1.1"
    width="100%"
    viewBox="0 0 97.0 98.0"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      width: '100%',
    }}
  >
    <defs>
      <clipPath id="IconSalesToolkit-i0">
        <path d="M1236,0 L1236,734 L0,734 L0,0 L1236,0 Z" />
      </clipPath>
      <filter
        id="IconSalesToolkit-i1"
        x="-6.18556701%"
        y="-6.12244898%"
        filterUnits="userSpaceOnUse"
        width="108.247423%"
        height="108.163265%"
      >
        <feGaussianBlur stdDeviation="1" in="SourceAlpha" result="i2" />
        <feOffset dx="0" dy="0" in="i2" result="i3" />
        <feColorMatrix
          values="0 0 0 0.0 0 0 0 0 0.0 0 0 0 0 0.0 0 0 0 0 0.2 0"
          type="matrix"
          in="i3"
        />
      </filter>
      <clipPath id="IconSalesToolkit-i4">
        <path d="M70,0 C82.7025492,-2.33342044e-15 93,10.2974508 93,23 L93,71 C93,83.7025492 82.7025492,94 70,94 L23,94 C10.2974508,94 1.55561363e-15,83.7025492 0,71 L0,23 C-1.55561363e-15,10.2974508 10.2974508,-1.21929324e-15 23,0 L70,0 Z" />
      </clipPath>
      <filter
        id="IconSalesToolkit-i5"
        x="-22.2222222%"
        y="-20.4025102%"
        filterUnits="userSpaceOnUse"
        width="131.746032%"
        height="134.004184%"
      >
        <feGaussianBlur stdDeviation="2" in="SourceAlpha" result="i6" />
        <feOffset dx="0" dy="2" in="i6" result="i7" />
        <feColorMatrix
          values="0 0 0 0.0 0 0 0 0 0.0 0 0 0 0 0.0 0 0 0 0 0.3 0"
          type="matrix"
          in="i7"
        />
      </filter>
      <clipPath id="IconSalesToolkit-i8">
        <path d="M27.8281461,0 C34.1624775,0 39.3066337,4.46797753 39.6228652,11.2657303 L48.0885393,11.2657303 C51.9056337,11.2657303 55,14.3600967 55,18.177191 L55,39.8162921 C55,45.8914244 50.0751322,50.8162921 44,50.8162921 L11,50.8162921 C4.92486775,50.8162921 1.66553297e-15,45.8914244 0,39.8162921 L0,22.2657303 C1.95391155e-15,16.1905981 4.92486775,11.2657303 11,11.2657303 L16.033427,11.2657303 C16.3473596,4.46828652 21.4963483,0 27.8281461,0 Z M27.8281461,3.89820225 C23.639618,3.89820225 20.2407354,7.55786517 19.936573,11.2657303 L35.7240449,11.2657303 C35.4150562,7.55780337 32.0115449,3.89820225 27.8281461,3.89820225 Z" />
      </clipPath>
      <clipPath id="IconSalesToolkit-i9">
        <path d="M11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 Z" />
      </clipPath>
      <clipPath id="IconSalesToolkit-i10">
        <path d="M20.4540863,1.08029241 C21.3082734,0.10264076 23.0428564,-0.285674177 24.3276887,0.225701318 C25.612521,0.737076812 26.6158156,2.20014489 26.5679746,3.50597437 C26.518776,4.81180384 27.0587009,6.31040112 27.722987,6.94348602 C28.3872731,7.57657091 29.8881103,8.08522308 31.1866245,7.99361024 C32.4851386,7.9019694 33.9900699,8.86185295 34.5354535,10.1252924 C35.064251,11.4609454 34.7813065,12.9841856 33.8067124,14.0411356 C32.8485294,14.9244301 32.1691968,16.3628903 32.1937961,17.2831142 C32.2183954,18.203338 32.9360091,19.6171903 33.9187914,20.4786072 C34.9029349,21.3400941 35.28428,23.072519 34.7730834,24.3605664 C34.2618869,25.6486138 32.7993308,26.656383 31.4939582,26.6044019 C30.1885857,26.5524207 28.6946069,27.0843436 28.0617435,27.7488622 C27.4288802,28.4133809 26.920406,29.9147435 27.0119868,31.2137121 C27.1035605,32.5127161 26.1370145,34.0113131 24.8741921,34.556888 C23.6113697,35.1024624 21.8617751,34.7770639 20.973296,33.8253714 C20.0834872,32.8736788 18.6359776,32.1982172 17.7256285,32.2118906 C16.8152794,32.2255772 15.3882751,32.9434071 14.533983,33.9197076 C13.679796,34.8973592 11.9479772,35.2856742 10.6603806,34.7742987 C9.37278393,34.2629232 8.36813172,32.7998551 8.41733032,31.4940253 C8.46652892,30.1881958 7.92660402,28.6964243 7.26231794,28.0633394 C6.59803186,27.4302545 5.09719462,26.9216024 3.7986805,27.0132152 C2.50016708,27.1048211 1.0020592,26.1449375 0.449852155,24.8746722 C-0.103719647,23.604547 0.239340897,21.8543399 1.19479454,20.9724106 C2.15021317,20.0891161 2.82818982,18.6369693 2.80085241,17.7304321 C2.77352374,16.8238598 2.05591002,15.3922605 1.07858647,14.5390346 C0.102641572,13.6845485 -0.285537448,11.948028 0.225659068,10.6640762 C0.736855654,9.3787591 2.20627018,8.3778542 3.5047836,8.42024071 C4.80333271,8.46263073 6.3014056,7.92934264 6.93426896,7.26482403 C7.56713231,6.60030542 8.0756065,5.09894281 7.98402572,3.79997415 C7.89245194,2.50100548 8.85882302,0.995547389 10.1218204,0.449972849 C11.3849227,-0.096966853 13.1372467,0.243483421 14.0188674,1.195176 C14.9018528,2.14683358 16.3493624,2.8291448 17.2597115,2.80179606 C18.1700605,2.77442283 19.6011589,2.05659291 20.4540863,1.08029241 Z M20.5847398,11.4947999 C18.8594314,10.8091177 16.93174,10.8372103 15.2275438,11.5720779 C13.5219089,12.3071254 12.1787795,13.6911081 11.4945906,15.4165543 C10.808981,17.1420364 10.8370707,19.0699219 11.5732671,20.7742897 C12.3093196,22.4800603 13.693163,23.8219221 15.4184355,24.5061799 C17.1448229,25.1918549 19.0725144,25.1623595 20.7767105,24.4246862 L20.7870725,24.4245855 C22.4885712,23.6867323 23.8260898,22.3041525 24.5088761,20.5801091 C25.190274,18.8560657 25.1621843,16.9325686 24.4273906,15.2310065 C23.6924531,13.525128 22.3100123,12.1818993 20.5847398,11.4947999 Z" />
      </clipPath>
    </defs>
    <g transform="translate(-64.0 -37.0)">
      <g clipPath="url(#IconSalesToolkit-i0)">
        <g transform="translate(66.0 39.0)">
          <path
            d="M23,0 L70,0 C82.7025492,-2.33342044e-15 93,10.2974508 93,23 L93,71 C93,83.7025492 82.7025492,94 70,94 L23,94 C10.2974508,94 1.55561363e-15,83.7025492 0,71 L0,23 C-1.55561363e-15,10.2974508 10.2974508,-1.21929324e-15 23,0 Z"
            stroke="none"
            fill="#000000"
            filter="url(#IconSalesToolkit-i1)"
          />
          <g clipPath="url(#IconSalesToolkit-i4)">
            <polygon
              points="0,0 93,0 93,94 0,94 0,0"
              stroke="none"
              fill="#44D7B6"
            />
          </g>
          <g transform="translate(14.0 19.999999999999996)">
            <g transform="translate(6.0 0.0)">
              <path
                d="M48.0885393,11.2657303 L39.6228652,11.2657303 C39.3066337,4.46797753 34.1624775,0 27.8281461,0 C21.4963483,0 16.3473596,4.46828652 16.033427,11.2657303 L11,11.2657303 C4.92486775,11.2657303 1.95391155e-15,16.1905981 0,22.2657303 L0,39.8162921 C1.66553297e-15,45.8914244 4.92486775,50.8162921 11,50.8162921 L44,50.8162921 C50.0751322,50.8162921 55,45.8914244 55,39.8162921 L55,18.177191 C55,14.3600967 51.9056337,11.2657303 48.0885393,11.2657303 L48.0885393,11.2657303 L48.0885393,11.2657303 Z M19.936573,11.2657303 C20.2407354,7.55786517 23.639618,3.89820225 27.8281461,3.89820225 C32.0115449,3.89820225 35.4150562,7.55780337 35.7240449,11.2657303 L19.936573,11.2657303 Z"
                stroke="none"
                fill="#000000"
                filter="url(#IconSalesToolkit-i5)"
              />
              <g clipPath="url(#IconSalesToolkit-i8)">
                <polygon
                  points="0,0 55,0 55,50.8162921 0,50.8162921 0,0"
                  stroke="none"
                  fill="#F8F8F8"
                />
              </g>
            </g>
            <g transform="translate(0.0 20.0)">
              <g transform="translate(7.0 9.0)">
                <g clipPath="url(#IconSalesToolkit-i9)">
                  <polygon
                    points="0,0 22,0 22,22 0,22 0,0"
                    stroke="none"
                    fill="#FFFFFF"
                  />
                </g>
              </g>
              <g clipPath="url(#IconSalesToolkit-i10)">
                <polygon
                  points="-5.55111512e-17,-2.77555756e-17 35,-2.77555756e-17 35,35 -5.55111512e-17,35 -5.55111512e-17,-2.77555756e-17"
                  stroke="none"
                  fill="#2859FF"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default IconSalesToolkit;
